import axios from "@/libs/axios";

const endpointPrefix = process.env.VUE_APP_API_PREFIX;

export default {
  transactions(params) {
    return axios.get(`/${endpointPrefix}/transactions`, { params });
  },
}
